import { Configuration, PublicClientApplication } from '@azure/msal-browser';
import { MSAL_CLIENT_ID, MSAL_AUTHORITY } from '../utils/constants';

export const msalConfig: Configuration = {
    auth: {
        clientId: MSAL_CLIENT_ID,
        authority: MSAL_AUTHORITY,
        redirectUri: window.location.origin + '/auth/msal',
        postLogoutRedirectUri: window.location.origin + '/',
    },
    cache: {
        cacheLocation: 'localStorage',
    },
};

// Scopes requested during sign-in
export const loginRequest = {
    scopes: ['openid', 'profile', 'email', 'User.Read'],
};

// Singleton MSAL instance – call msalInstance.initialize() before first use
export const msalInstance = new PublicClientApplication(msalConfig);
